import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { formatarCampoInteiro } from "../shared";

export default function ConsumoFio({ consumo }) {
    return (
        <div>
            <DataTable
                responsiveLayout="scroll"
                size="small"
                value={consumo}
            >
                <Column header="Artigo" field="artigo" sortable />
                <Column header="Trama" field="trama1" sortable />
                <Column header="Urdume" field="urdume1" sortable />
                <Column header="Picanol" field="picanol" body={formatarCampoInteiro} sortable />
                <Column header="Consumo Trama" field="consumotrama1_picanol" body={formatarCampoInteiro} sortable />
                <Column header="Consumo Urdume" field="consumourdume1_picanol" body={formatarCampoInteiro} sortable />
                <Column header="Toyota" field="toyota" body={formatarCampoInteiro} sortable />
                <Column header="Consumo Trama" field="consumotrama1_toyota" body={formatarCampoInteiro} sortable />
                <Column header="Consumo Urdume" field="consumourdume1_toyota" body={formatarCampoInteiro} sortable />
            </DataTable>
        </div>
    );
}
